var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeHasReferred = function SvgCassiopeiaBadgeHasReferred(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.506,
    height: 35.462,
    viewBox: "0 0 6.484 9.383",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M130.828 164.086c-.816 0-1.55.34-2.078.88l-1.195 1.991 1.785 1.53a.443.443 0 0 1 .08.58l-1.36 2.057 1.23 2.049c1.872-1.043 4.024-3.328 4.375-5.51.05-.213.079-.434.079-.662a2.916 2.916 0 0 0-2.915-2.915z",
    style: {
      fill: "#d1a600",
      fillOpacity: 1,
      stroke: "#5a4800",
      strokeWidth: 0.295457,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-127.408 -163.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.762 164.59c-.628 0-1.192.262-1.598.678l-.918 1.53 1.371 1.174c.13.112.528.824.434.967l-1.344 2.14.831 1.331c1.44-.8 3.392-3.297 3.662-4.974.038-.163.06-.333.06-.509 0-1.237-1.261-2.337-2.498-2.337z",
    style: {
      fill: "#dd2e44",
      fillOpacity: 1,
      stroke: "#8c0000",
      strokeWidth: 0.227043,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-127.408 -163.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.394 166.015c.802.81.304 1.809-.127 2.753-.813 1.284-1.054 1.334-.485.027.348-.798.872-1.93.1-2.713-.813-.825-.7-.948.512-.067z",
    style: {
      fill: "#fff",
      fillOpacity: 0.5,
      strokeWidth: 0.265112,
      strokeLinejoin: "round",
      strokeDasharray: ".795337,.265112",
      strokeDashoffset: 0.291624,
      strokeOpacity: 0.5
    },
    transform: "translate(-127.408 -163.938)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeHasReferred);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-has-referred.664b5850b121968c2811f5fff20097e9.svg";